import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNetworkKey, getSpaceKey, getSpacePostTypesKey, getSpacesKey, } from '../../utils/keys';
export const useDeleteSpacePostTypes = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.spacePostType.delete(input), {
        onSettled: () => {
            const spacePostTypeKey = getSpacePostTypesKey();
            queryClient.invalidateQueries(spacePostTypeKey);
            queryClient.invalidateQueries(getSpacesKey());
            queryClient.invalidateQueries(getSpaceKey());
            queryClient.invalidateQueries(getNetworkKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useDeleteSpacePostTypes.js.map